<template>
<div class="chapter">
<div class="inner_page">
<div class="body"><a id="part_1"></a><p class="pn"><a href="#/ItalianLover_toc#part_1"><span class="small">PART I</span></a></p><p class="pt"><em><strong>Preproduction</strong></em></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ItalianLover_part_1.vue?1f1aa246